import { Action } from '@ngrx/store';


import { SingleResponseModel } from '../../../../common/models/single-response.model';
import { PaginableResponseModel } from '../../../../common/models/paginable-response.model';

import { SummaryTicketListDto, SummaryTicketModel } from '../../models/summary-ticket.model';


export enum TicketActionTypes {
  LoadTickets = '[Tickets] Load Tickets',
  LoadTicketsSuccess = '[Tickets] Load Tickets Success',
  LoadTicketsFailure = '[Tickets] Load Tickets Failure',

  LoadTicket = '[Ticket] Load Ticket',
  LoadTicketSuccess = '[Ticket] Load Ticket Success',
  LoadTicketFailure = '[Ticket] Load Ticket Failure',

  CreateTicket = '[Ticket] Create Ticket',
  CreateTicketSuccess = '[Ticket] Create Ticket Success',
  CreateTicketFailure = '[Ticket] Create Ticket Failure',

  UpdateTicket = '[Ticket] Update Ticket',
  UpdateTicketSuccess = '[Ticket] Update Ticket Success',
  UpdateTicketFailure = '[Ticket] Update Ticket Failure',

  DeleteTicket = '[Ticket] Delete Ticket',
  DeleteTicketSuccess = '[Ticket] Delete Ticket Success',
  DeleteTicketFailure = '[Ticket] Delete Ticket Failure',
}

/** Load all */

export class LoadTickets implements Action {
  readonly type = TicketActionTypes.LoadTickets;
  constructor(public payload: {filter: any}) {}
}

export class LoadTicketsSuccess implements Action {
  readonly type = TicketActionTypes.LoadTicketsSuccess;
  constructor(public payload: {
    items: SummaryTicketModel[];
    total: number;
    summary: SummaryTicketListDto;
  }) {}
}




export class LoadTicketsFailure implements Action {
  readonly type = TicketActionTypes.LoadTicketsFailure;
  constructor(public payload: { error: any }) {}
}

/** Load by id */

export class LoadTicket implements Action {
  readonly type = TicketActionTypes.LoadTicket;
  constructor(public payload: { uid: string }) {}
}

export class LoadTicketSuccess implements Action {
  readonly type = TicketActionTypes.LoadTicketSuccess;
  constructor(public payload: SingleResponseModel<SummaryTicketModel>) {}
}

export class LoadTicketFailure implements Action {
  readonly type = TicketActionTypes.LoadTicketFailure;
  constructor(public payload: { error: any }) {}
}

/** Create */

export class CreateTicket implements Action {
  readonly type = TicketActionTypes.CreateTicket;
  constructor(public payload: { ticket: SummaryTicketModel }) {}
}


export class CreateTicketSuccess implements Action {
  readonly type = TicketActionTypes.CreateTicketSuccess;
  constructor(public payload: { ticket: SummaryTicketModel }) {}
}

export class CreateTicketFailure implements Action {
  readonly type = TicketActionTypes.CreateTicketFailure;
  constructor(public payload: { error: any }) {}
}


/** Update */

export class UpdateTicket implements Action {
  readonly type = TicketActionTypes.UpdateTicket;
  constructor(public payload: { ticket: SummaryTicketModel }) {}
}

export class UpdateTicketSuccess implements Action {
  readonly type = TicketActionTypes.UpdateTicketSuccess;
  constructor(public payload: { ticket: SummaryTicketModel }) {}
}

export class UpdateTicketFailure implements Action {
  readonly type = TicketActionTypes.UpdateTicketFailure;
  constructor(public payload: { error: any }) {}
}


/** Delete */

export class DeleteTicket implements Action {
  readonly type = TicketActionTypes.DeleteTicket;
  constructor(public payload: { uid: string }) {}
}

export class DeleteTicketSuccess implements Action {
  readonly type = TicketActionTypes.DeleteTicketSuccess;
  constructor(public payload: { uid: string }) {}
}

export class DeleteTicketFailure implements Action {
  readonly type = TicketActionTypes.DeleteTicketFailure;
  constructor(public payload: { error: any }) {}
}

export type TicketActions =
  | LoadTickets
  | LoadTicketsSuccess
  | LoadTicketsFailure
  | LoadTicket
  | LoadTicketSuccess
  | LoadTicketFailure
  | CreateTicket
  | CreateTicketSuccess
  | CreateTicketFailure
  | UpdateTicket
  | UpdateTicketSuccess
  | UpdateTicketFailure
  | DeleteTicket
  | DeleteTicketSuccess
  | DeleteTicketFailure
